'use client';

import '@ui5/webcomponents/dist/TableColumn.js';
import { TableColumnPopinDisplay } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `TableColumn` component allows to define column specific properties that are applied when rendering the `Table` component.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Table" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const TableColumn = withWebComponent('ui5-table-column', ['minWidth', 'popinDisplay', 'popinText'], ['demandPopin'], [], []);
TableColumn.displayName = 'TableColumn';
TableColumn.defaultProps = {
  minWidth: Infinity,
  popinDisplay: TableColumnPopinDisplay.Block
};
export { TableColumn };